<template>
    <el-card>
        <el-row class="report__title">游戏房分成账单</el-row>
        <!-- 搜索 -->
        <el-row class="report__search">
            <div class="item">
                <el-date-picker v-model="dateTime" type="daterange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" @change="handleDateChange">
                </el-date-picker>
            </div>
            <div class="item">
                <span>状态：</span>
                <el-select v-model="search.status" placeholder="请选择状态" clearable>
                    <el-option label="未结算" :value="0"></el-option>
                    <el-option label="已结算" :value="1"></el-option>
                    <el-option label="拒绝结算" :value="2"></el-option>
                </el-select>
            </div>
            <div class="item">
                <span>账单类型：</span>
                <el-select v-model="search.billType" placeholder="请选择账单类型" clearable>
                    <el-option label="房主奖励" :value="0"></el-option>
                    <el-option label="助理奖励" :value="1"></el-option>
                </el-select>
            </div>
            <div class="item">
                <span>RID：</span>
                <el-input v-model="search.rid" style="width: 150px" placeholder="请输入RID"></el-input>
            </div>
            <div class="item">
                <el-button type="primary" @click="getList(1)">search</el-button>
                <el-button type="success" @click="handleBatchSettle" :disabled="selectedRows.length === 0">批量结算</el-button>
                <el-button type="danger" @click="handleBatchReject" :disabled="selectedRows.length === 0">批量拒绝</el-button>
                <el-button type="warning" @click="handleAllSettlement">结算上周数据</el-button>
            </div>
        </el-row>
        <!-- 表格 -->
        <el-row>
            <el-table border :data="tableList" @selection-change="handleSelectionChange" height="600">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="id" label="ID" align="center" width="80"></el-table-column>
                <el-table-column prop="rid" label="RID" align="center" width="120"></el-table-column>
                <el-table-column prop="name" label="昵称" align="center" width="120"></el-table-column>
                <el-table-column prop="billType" label="账单类型" align="center" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.billType === 0">房主奖励</span>
                        <span v-else-if="scope.row.billType === 1">助理奖励</span>
                    </template>
                </el-table-column>
                <el-table-column prop="reward" label="奖励" align="center" width="120"></el-table-column>
                <el-table-column prop="ownerRid" label="房主RID" align="center" width="120"></el-table-column>
                <el-table-column prop="level" label="房间等级" align="center" width="100"></el-table-column>
                <el-table-column prop="activeUser" label="有效用户数" align="center" width="120"></el-table-column>
                <el-table-column prop="betCoins" label="下注金额" align="center" width="120"></el-table-column>
                <el-table-column prop="cycleStartAt" label="数据周期开始时间" align="center" width="180"></el-table-column>
                <el-table-column prop="cycleEndAt" label="数据周期结束时间" align="center" width="180"></el-table-column>
                <el-table-column prop="createDate" label="账单生成时间" align="center" width="180"></el-table-column>
                <el-table-column prop="status" label="状态" align="center" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status === 0" style="color: #E6A23C;">未结算</span>
                        <span v-else-if="scope.row.status === 1" style="color: #67C23A;">已结算</span>
                        <span v-else-if="scope.row.status === 2" style="color: #F56C6C;">拒绝结算</span>
                    </template>
                </el-table-column>
                <el-table-column prop="riskLabel" label="房主风险标签" align="center" width="120"></el-table-column>
                <el-table-column prop="rewardStatus" label="账单用户状态" align="center" width="120"></el-table-column>
                <el-table-column prop="isGameRoom" label="是否是游戏房间" align="center" width="140">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isGameRoom === 0" style="color: #909399;">不是</span>
                        <span v-else-if="scope.row.isGameRoom === 1" style="color: #67C23A;">是</span>
                    </template>
                </el-table-column>
                <el-table-column prop="reason" label="拒绝原因" align="center" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="operator" label="操作人" align="center" width="120"></el-table-column>
                <el-table-column label="操作" align="center" width="200" fixed="right">
                    <template slot-scope="scope">
                        <div class="btns">
                            <el-button v-if="scope.row.status === 0" type="primary" size="mini"
                                @click="handleRefresh(scope.row)">刷新</el-button>
                            <el-button v-if="scope.row.status === 0" type="success" size="mini"
                                @click="handleSettle(scope.row)">结算</el-button>
                            <el-button v-if="scope.row.status === 0" type="danger" size="mini"
                                @click="handleReject(scope.row)">拒绝</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <!-- 分页 -->
        <el-row>
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize"
                :current-page.sync="currentPage" @current-change="guaranteedHandleCurrentChange">
            </el-pagination>
        </el-row>
        <!-- 结算/拒绝对话框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%" @close="remarkDialogClose">
            <el-row>
                <span>操作人：{{ $store.getters.username }}</span>
            </el-row>
            <el-form :model="handleInfo" :rules="dialogRules" ref="handleInfo" label-width="100px">
                <el-form-item label="选择操作" prop="status">
                    <el-radio-group v-model="handleInfo.status">
                        <el-radio :label="1">结算</el-radio>
                        <el-radio :label="2">拒绝结算</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="原因" prop="reason" v-if="handleInfo.status === 2">
                    <el-input type="textarea" v-model="handleInfo.reason" placeholder="请输入拒绝原因" :rows="5"></el-input>
                </el-form-item>
            </el-form>
            <el-row style="margin-top: 20px;">
                <el-button type="info" @click="remarkDialogClose">取消</el-button>
                <el-button type="primary" @click="handleReportSubmits">提交</el-button>
            </el-row>
        </el-dialog>
    </el-card>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            currentPage: 1,
            total: 0,
            tableList: [],
            pageSize: 30,
            dateTime: [],
            selectedRows: [],
            search: {
                startDate: null,
                endDate: null,
                status: null,
                billType: null,
                rid: null,
            },
            handleInfo: {
                status: 1,
                reason: null,
                ids: [],
            },
            dialogRules: {
                status: [
                    { required: true, message: '请选择操作类型', trigger: 'change' }
                ],
                reason: [
                    { required: true, message: '请输入拒绝原因', trigger: 'blur' }
                ]
            },
            dialogTitle: '',
            isBatch: false
        }
    },
    created() {
        this.getList()
    },
    methods: {
        guaranteedHandleCurrentChange(page) {
            this.currentPage = page
            this.getList()
        },
        handleDateChange() {
            console.log(this.dateTime)
            if (!this.dateTime) {
                this.search.startDate = null
                this.search.endDate = null
                return
            }
            this.search.startDate = this.dateTime[0] ? this.dateTime[0] : null
            this.search.endDate = this.dateTime[1] ? this.dateTime[1] : null
        },

        // 获取数据列表
        async getList(page) {
            if (page) {
                this.currentPage = 1
            }
            const { data: res } = await this.$axios({
                method: 'post',
                url: this.$store.getters.path.game_room_bill_list,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data: {
                    ...this.search,
                    page: this.currentPage,
                },
            })
            if (res.code === 0 || res.status === 0) {
                this.tableList = res.data.data
                this.total = res.data.total
            } else {
                this.$message.error(res.msg || res.message)
            }
        },

        // 表格选择变化
        handleSelectionChange(selection) {
            this.selectedRows = selection
        },

        // 刷新单条数据
        async handleRefresh(row) {
            try {
                const { data: res } = await this.$axios({
                    method: 'get',
                    url: this.$store.getters.path.game_room_bill_refresh,
                    params: {
                        username: this.$store.getters.username,
                        token: this.$store.getters.token,
                        id: row.id,
                    }
                })
                
                if (res.code === 0 || res.status === 0) {
                    this.$message.success('刷新成功')
                    this.getList()
                } else {
                    this.$message.error(res.msg || res.message)
                }
            } catch (error) {
                console.error('刷新失败:', error)
                this.$message.error('刷新失败')
            }
        },

        // 结算单条
        handleSettle(row) {
            this.isBatch = false
            this.dialogTitle = '结算账单'
            this.handleInfo = {
                status: 1,
                reason: null,
                ids: [row.id],
            }
            this.dialogVisible = true
        },

        // 拒绝单条
        handleReject(row) {
            this.isBatch = false
            this.dialogTitle = '拒绝结算'
            this.handleInfo = {
                status: 2,
                reason: null,
                ids: [row.id],
            }
            this.dialogVisible = true
        },

        // 批量结算
        handleBatchSettle() {
            this.isBatch = true
            this.dialogTitle = '批量结算'
            this.handleInfo = {
                status: 1,
                reason: null,
                ids: this.selectedRows.map(row => row.id),
            }
            this.dialogVisible = true
        },

        // 批量拒绝
        handleBatchReject() {
            this.isBatch = true
            this.dialogTitle = '批量拒绝'
            this.handleInfo = {
                status: 2,
                reason: null,
                ids: this.selectedRows.map(row => row.id),
            }
            this.dialogVisible = true
        },

        remarkDialogClose() {
            this.dialogVisible = false
            this.handleInfo = {
                status: 1,
                reason: null,
                ids: [],
            }
            this.isBatch = false
        },

        async handleReportSubmits() {
            this.$refs.handleInfo.validate(async (valid) => {
                if (valid) {
                    try {
                        const { data: res } = await this.$axios({
                            method: 'post',
                            url: this.$store.getters.path.game_room_bill_settle,
                            params: {
                                username: this.$store.getters.username,
                                token: this.$store.getters.token,
                            },
                            data: {
                                ids: this.handleInfo.ids,
                                status: this.handleInfo.status,
                                reason: this.handleInfo.reason || ''
                            }
                        })

                        if (res.code === 0 || res.status === 0) {
                            this.$message.success('操作成功')
                            this.remarkDialogClose()
                            this.getList()
                        } else {
                            this.$message.error(res.msg || res.message)
                        }
                    } catch (error) {
                        console.error('操作失败:', error)
                        this.$message.error('操作失败')
                    }
                }
            })
        },

        // 全部结算
        async handleAllSettlement() {
            try {
                await this.$confirm('确定要全部结算吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })

                const { data: res } = await this.$axios({
                    method: 'post',
                    url: this.$store.getters.path.game_room_bill_all_settlement,
                    params: {
                        username: this.$store.getters.username,
                        token: this.$store.getters.token,
                    },
                    timeout: 60000 // 1分钟超时
                })

                if (res.code === 0 || res.status === 0) {
                    this.$message.success('全部结算成功')
                    this.getList()
                } else {
                    this.$message.error(res.msg || res.message)
                }
            } catch (error) {
                if (error !== 'cancel') {
                    console.error('全部结算失败:', error)
                    this.$message.error('全部结算失败')
                }
            }
        },
    },
}
</script>

<style scoped lang="scss">
.report {
    &__title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 20px;
    }

    &__search {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;

        span {
            font-size: 20px;
            font-weight: 600;
            margin-right: 15px;
        }

        .searchBtn {
            margin-left: 10px;
        }
    }
}

.btns {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;

    :deep(.el-button) {
        width: 80px;
        margin-left: 0;
    }
}
</style>